import dayjs from 'dayjs'

import { Button } from '@/components/button/button'
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from '@/components/card/card'
import { Checkbox } from '@/components/checkbox/checkbox'

import { cn } from '@/lib/utils'

import { useConfirmWithSubscriptionCard } from './use-confirm-with-subscription-card'

export interface ConfirmWithSubscriptionProps {
  subscriptionExpiryDate: string
  onClickCancelButton: VoidFunction
}

export const ConfirmWithSubscriptionCard = ({
  subscriptionExpiryDate,
  onClickCancelButton,
}: ConfirmWithSubscriptionProps) => {
  const {
    isCheckedToDeleteRightNow,
    isLoadingDeleteButton,
    isDisabledDeleteButton,
    isDisabledCancelButton,
    handleChangeChecked,
    handleClickDeleteButton,
  } = useConfirmWithSubscriptionCard()

  const formattedExpiryDate = subscriptionExpiryDate ? dayjs.utc(subscriptionExpiryDate).format('MMMM D, YYYY') : '-'

  return (
    <Card className={cn('max-w-[500px]')}>
      <CardHeader>
        <CardTitle>Account Deletion is a Permanent Action</CardTitle>
      </CardHeader>
      <CardContent>
        <p className={cn('text-[14px] font-normal leading-[24px] text-muted-foreground')}>
          Your subscription remains active until {formattedExpiryDate}. If you still wish to permanently delete your
          account along with all registered members, applicants, and cases, please check the box to proceed with the
          deletion.
        </p>

        <label className={cn('flex items-center gap-x-2', 'mt-5', 'cursor-pointer')}>
          <Checkbox variant="black" checked={isCheckedToDeleteRightNow} onCheckedChange={handleChangeChecked} />
          <span className={cn('text-[12px] font-medium leading-[20px] text-muted-foreground')}>
            Yes, I would like to permanently delete my account now.
          </span>
        </label>
      </CardContent>
      <CardFooter className={cn('flex gap-x-3')}>
        <Button
          type="button"
          variant="destructive"
          className={cn('w-2/3')}
          disabled={isDisabledDeleteButton}
          loading={isLoadingDeleteButton}
          onClick={handleClickDeleteButton}
        >
          Permanently delete
        </Button>
        <Button
          type="button"
          variant="secondary"
          className={cn('w-1/3')}
          disabled={isDisabledCancelButton}
          onClick={onClickCancelButton}
        >
          Cancel
        </Button>
      </CardFooter>
    </Card>
  )
}
